<template>
  <div class="comContent">
    <div class="search-container">
      <el-form ref="formTool" :model="formTool" :inline="true">
        <el-form-item label="" prop="name">
          <el-input
            v-model="formTool.name"
            placeholder="请输入企业名称"
            size="small"
            style="width: 140px"
          />
        </el-form-item>
        <el-form-item label="" prop="shopTypeCode">
          <el-select
            v-model="formTool.shopTypeCode"
            placeholder="请选择企业类型"
            size="small"
            style="width: 150px"
          >
            <el-option label="药品经营企业" value="3" />
            <el-option label="药品生产企业" value="4" />
          </el-select>
        </el-form-item>
        <el-form-item label="经营时间" prop="businessTimeRange">
          <el-date-picker
            v-model="formTool.businessTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            :picker-options="dateShortcuts"
            style="width: 260px"
          />
        </el-form-item>
        <el-form-item label="订单创建时间" prop="orderCreateTimeRange">
          <el-date-picker
            v-model="formTool.orderCreateTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            :picker-options="dateShortcuts"
            style="width: 260px"
          />
        </el-form-item>
        <el-form-item label="订单完成时间" prop="orderCompleteTimeRange">
          <el-date-picker
            v-model="formTool.orderCompleteTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            :picker-options="dateShortcuts"
            style="width: 260px"
          />
        </el-form-item>
      </el-form>
      <div class="form-buttons">
        <div>
          <MyButton
            type="primary"
            text="查询"
            @click="handleSearchFirstPage()"
          />
        </div>
        <div>
          <MyButton type="info" text="重置" @click="reset()" />
        </div>
        <div>
          <MyButton type="success" text="导出" @click="exportData()" />
        </div>
      </div>
    </div>
    <div class="center" v-loading="loading">
      <MyTable
        :table-data="tableData"
        :index="index"
        :selection="selection"
        :page="page"
        :operation="operation"
        :table-option.sync="tableOption"
        @page-change="getShopList"
      >
        <!-- 自定义列可以在这里添加 -->
      </MyTable>
    </div>
  </div>
</template>

<script>
import MyButton from "@/components/myButton";
import MyTable from "@/components/myTable";
import { shopStatusList, exportShopStatusList } from "@/api/auditcenter";
import dayjs from "dayjs";
export default {
  components: { MyButton, MyTable },
  data() {
    return {
      formTool: {
        name: "",
        shopTypeCode: "",
        businessTimeRange: [],
        orderCreateTimeRange: [],
        orderCompleteTimeRange: [],
      },
      operation: false,
      selection: false,
      index: false,
      tableData: [],
      tableOption: [
        { label: "名称", prop: "name", width: 200  },
        { label: "企业类型", prop: "shopTypeName", width: 100  },
        { label: "统一社会信用代码", prop: "shopCode", width: 200 },
        { label: "地址", prop: "address", width: 200  },
        { label: "店铺名称", prop: "shopName" , width: 200 },
        { label: "店铺唯一标识", prop: "id", width: 200  },
        { label: "康贝号", prop: "merchantNo" , width: 100 },
        { label: "联系人姓名", prop: "concatName" , width: 100 },
        { label: "联系电话", prop: "concatPhone" , width: 150 },
        { label: "经营开始时间", prop: "startManageTime" , width: 200 },
        { label: "经营结束时间", prop: "endManageTime", width: 200  },
        { label: "已完成订单数", prop: "finnishOrderQuantity" , width: 100 },
        { label: "在途订单数", prop: "routeOrderQuantity" , width: 100 },
        { label: "售后订单数", prop: "afterSaleOrderQuantity" , width: 100 },
      ],
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      dateShortcuts: {
        shortcuts: [
          {
            text: "近一月",
            onClick: (picker) => {
              const end = new Date();
              const start = new Date();
              start.setDate(end.getDate() - 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近两月",
            onClick: (picker) => {
              const end = new Date();
              const start = new Date();
              start.setDate(end.getDate() - 60);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近三月",
            onClick: (picker) => {
              const end = new Date();
              const start = new Date();
              start.setDate(end.getDate() - 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近半年",
            onClick: (picker) => {
              const end = new Date();
              const start = new Date();
              start.setDate(end.getDate() - 180);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近一年",
            onClick: (picker) => {
              const end = new Date();
              const start = new Date();
              start.setDate(end.getDate() - 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      loading: false,
    };
  },

  computed: {},
  created() {
    this.getShopList();
  },
  methods: {
    getShopList() {
      const params = this.pendParams();
      console.log(params);
      this.loading = true;
      shopStatusList(params)
        .then((res) => {
          if (res.code === 0) {
            this.tableData = res.data.records || [];
            this.page.total = res.data.total;
          }
        })
        .catch((error) => {
          console.error("获取店铺列表失败:", error);
          this.$message.error("获取数据失败，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSearchFirstPage() {
      this.page.current = 1;
      this.getShopList();
    },
    reset() {
      this.$refs.formTool.resetFields();
      this.formTool = {
        name: "",
        shopTypeCode: "",
        businessTimeRange: [],
        orderCreateTimeRange: [],
        orderCompleteTimeRange: [],
      };
      this.getShopList();
    },
    pendParams() {
      const params = {
        current: this.page.current,
        size: this.page.size,
        ...this.formTool,
      };

      // 处理日期范围格式
      if (params.businessTimeRange && params.businessTimeRange.length === 2) {
        params.startManageTime =
          dayjs(params.businessTimeRange[0]).format("YYYY-MM-DD") + " 00:00:00";
        params.endManageTime =
          dayjs(params.businessTimeRange[1]).format("YYYY-MM-DD") + " 23:59:59";
      }
      if (
        params.orderCreateTimeRange &&
        params.orderCreateTimeRange.length === 2
      ) {
        params.orderCreateTime =
          dayjs(params.orderCreateTimeRange[0]).format("YYYY-MM-DD") +
          " 00:00:00";
        params.orderCreateTimeEnd =
          dayjs(params.orderCreateTimeRange[1]).format("YYYY-MM-DD") +
          " 23:59:59";
      }
      if (
        params.orderCompleteTimeRange &&
        params.orderCompleteTimeRange.length === 2
      ) {
        params.startFinishOrderTime =
          dayjs(params.orderCompleteTimeRange[0]).format("YYYY-MM-DD") +
          " 00:00:00";
        params.endFinishOrderTime =
          dayjs(params.orderCompleteTimeRange[1]).format("YYYY-MM-DD") +
          " 23:59:59";
      }

      // 删除范围数组，避免传递给后端
      delete params.businessTimeRange;
      delete params.orderCreateTimeRange;
      delete params.orderCompleteTimeRange;
      return params;
    },
    exportData() {
      // 实现导出功能
      const params = this.pendParams();
      exportShopStatusList(params);
    },
    handleSelectionChange(val) {
      // 处理选择变化
    },
  },
};
</script>

<style lang="scss" scoped>
.comContent {
  padding: 12px;
  background: #fff;
}
.search-container {
  display: flex;
}
.form-buttons {
  display: flex;
  gap: 8px;
  margin-top: 4px;
}
.center {
  height: calc(100% - 120px);
}

// 调整表单项间距
.el-form-item {
  margin-right: 10px;
}
</style>